import { render, staticRenderFns } from "./mini-program-generate-share.vue?vue&type=template&id=048334f8&scoped=true"
import script from "./mini-program-generate-share.vue?vue&type=script&lang=js"
export * from "./mini-program-generate-share.vue?vue&type=script&lang=js"
import style0 from "./mini-program-generate-share.vue?vue&type=style&index=0&id=048334f8&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048334f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/AI合规前端-测试/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('048334f8')) {
      api.createRecord('048334f8', component.options)
    } else {
      api.reload('048334f8', component.options)
    }
    module.hot.accept("./mini-program-generate-share.vue?vue&type=template&id=048334f8&scoped=true", function () {
      api.rerender('048334f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/taxLaw/share/mini-program-generate-share.vue"
export default component.exports